import { render, staticRenderFns } from "./ph-empty.vue?vue&type=template&id=ad822b58&scoped=true"
import script from "./ph-empty.vue?vue&type=script&lang=js"
export * from "./ph-empty.vue?vue&type=script&lang=js"
import style0 from "./ph-empty.vue?vue&type=style&index=0&id=ad822b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad822b58",
  null
  
)

export default component.exports